<form [formGroup]="form" (ngSubmit)="searchClick()">
  <rask-input class="col-2" aid="fritextSokSandningsLogg" label="{{texts.SokText}}"
  formControlName="sokText"></rask-input>
  <rask-datepicker-interval
    labelStartDate="{{texts.Startdatum}}" labelEndDate="{{texts.Slutdatum}}" startDate="{{getStartDate()}}"
    endDate="{{getEndDate()}}" (startDate)="setFrom($event)" (endDate)="setTom($event)">
  </rask-datepicker-interval>
  <rask-submit-button color="secondary" aid="sandningsloggSok">{{texts.Sok}}</rask-submit-button>
</form>

@if (searchResult$ | async; as searchResult) {
  <div class="result-container">
    <rask-search-result [data]="searchResult"></rask-search-result>
  </div>
}